import {
  type TransferFormAction,
  type TransferFormState,
} from "./TransferForm.types";

export const initialTransferFormState: TransferFormState = {
  amount: "",
  fromPortfolio: "USDC",
};

export const transferFormReducer = (
  state: TransferFormState,
  action: TransferFormAction,
): TransferFormState => {
  switch (action.type) {
    case "SET_AMOUNT":
      return { ...state, amount: action.payload };

    case "SET_FROM_PORTFOLIO":
      return { ...state, fromPortfolio: action.payload };

    default:
      return state;
  }
};
